import { render, staticRenderFns } from "./NotifyAway.vue?vue&type=template&id=77b801f9&"
import script from "./NotifyAway.vue?vue&type=script&lang=js&"
export * from "./NotifyAway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports